import { render, staticRenderFns } from "./Artworks.vue?vue&type=template&id=4f54a5bc&scoped=true"
import script from "./Artworks.vue?vue&type=script&lang=js"
export * from "./Artworks.vue?vue&type=script&lang=js"
import style0 from "./Artworks.vue?vue&type=style&index=0&id=4f54a5bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54a5bc",
  null
  
)

export default component.exports